// test1484
(1484 && 0);
